import React from "react";
import "../ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../../i18n';
import { useTranslation } from 'react-i18next';

import ImageSpin26Transponder from "../../assets/images/modems/processed/combined_transponder_spin26.png"

const Spin26_BEACON = () => {
  const { t, i18n } = useTranslation();
  
  return (
     <Link to="/acoustic_modems#spin26_beacon_spec" className="card-link-wrapper">
          <div class="card-beacon">
            <img src={ImageSpin26Transponder} alt={t('products.types.communcation_26_BEACON.title')} class="card-image-beacon" />
            <div class="card-content">
              <h3 class="card-title">{t('products.types.communcation_26_BEACON.title')}</h3>
              <p className="card-description">
                <ul class="features-list">
                  <li>{t('products.types.communcation_26_BEACON.li_1')}</li>
                  <li>{t('products.types.communcation_26_BEACON.li_2')}</li>
                  <li>{t('products.types.communcation_26_BEACON.li_3')}</li>
                  <li>{t('products.types.communcation_26_BEACON.li_4')}</li>
                  <li>{t('products.types.communcation_26_BEACON.li_5')}</li>
                  <li>{t('products.types.communcation_26_BEACON.li_6')}</li>
                </ul>
              </p>
            </div>
          </div>
        </Link>
  );
};
export default Spin26_BEACON;